/**
 * Map Controls — DOM overlay with zoom in/out and fit-to-view buttons.
 *
 * Takes a camera reference and a way to get the canvas dimensions.
 * No PIXI dependency.
 */

export interface MapControlsCamera {
  zoomAt(mx: number, my: number, delta: number): void;
  fitToView(viewW: number, viewH: number): void;
}

export class MapControls {
  private container: HTMLElement;

  constructor(
    parentContainer: HTMLElement,
    camera: MapControlsCamera,
    getViewSize: () => { width: number; height: number },
  ) {
    const controls = document.createElement("div");
    controls.style.cssText = `
      position: absolute;
      bottom: 12px;
      right: 12px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      z-index: 10;
    `;
    parentContainer.style.position = "relative";

    const btnStyle = `
      width: 32px;
      height: 32px;
      border: 1px solid #1a2a3a;
      background: rgba(10,18,32,0.9);
      color: #8a9ab0;
      font-size: 16px;
      cursor: pointer;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    const zoomIn = document.createElement("button");
    zoomIn.textContent = "+";
    zoomIn.style.cssText = btnStyle;
    zoomIn.addEventListener("click", () => {
      const { width, height } = getViewSize();
      camera.zoomAt(width / 2, height / 2, -100);
    });

    const zoomOut = document.createElement("button");
    zoomOut.textContent = "\u2212";
    zoomOut.style.cssText = btnStyle;
    zoomOut.addEventListener("click", () => {
      const { width, height } = getViewSize();
      camera.zoomAt(width / 2, height / 2, 100);
    });

    const fitBtn = document.createElement("button");
    fitBtn.textContent = "\u2302";
    fitBtn.style.cssText = btnStyle;
    fitBtn.addEventListener("click", () => {
      const { width, height } = getViewSize();
      camera.fitToView(width, height);
    });

    controls.appendChild(zoomIn);
    controls.appendChild(zoomOut);
    controls.appendChild(fitBtn);
    parentContainer.appendChild(controls);
    this.container = controls;
  }

  show(visible: boolean): void {
    this.container.style.display = visible ? "flex" : "none";
  }

  destroy(): void {
    this.container.parentNode?.removeChild(this.container);
  }
}
